<ui-tabs>
        <ui-tab name="Documentation">
            <router-outlet></router-outlet>
        </ui-tab>
        <ui-tab name="More">
            TBD
        </ui-tab>
</ui-tabs>
